/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable()
export class ContentInjectionService {
    /**
     * Emitter to send action dots/dropdown content and position data.
     */
    public openEmitter: Subject<any> = new Subject<any>();

    /**
     * Emitter to close action dots/dropdown.
     */
    public closeEmitter: Subject<boolean> = new Subject<boolean>();

    /**
     * Stored open state.
     */
    public isOpen: Subject<any> = new Subject<any>();

    /**
     * Hold overlay if hovered over.
     */
    public contentHovered: boolean = false;

    constructor(
        private router: Router
    ) {
        this.subscribeToRouteChanges();
        this.subscribeToEmitters();
    }

    /**
     * Subscribe to route changes and close emitter on navigation.
     * @private
     */
    private subscribeToRouteChanges(): void {
        this.router.events.subscribe({
            next: (event: any): void => {
                if (event instanceof NavigationEnd) {
                    this.closeEmitter.next(true);
                }
            }
        });
    }

    /**
     * Subscribe to own emitters to store the open state of the component.
     * @private
     */
    private subscribeToEmitters(): void {
        this.openEmitter.subscribe({
            next: (event: any): void => {
                if (event.open) {
                    this.isOpen.next(event);
                }
            }
        });

        this.closeEmitter.subscribe({
            next: (event: boolean): void => {
                if (event) {
                    this.isOpen.next({ open: false });
                }
            }
        });
    }
}
